import React from 'react';
import { ToggleGroup, ToggleGroupItem } from '../../../ui/toggle-group';
import { FieldOption } from '../../types';
import { cn } from '../../../../lib/utils';

interface DocumentTagToggleProps {
    value: string[];
    onChange: (value: string[]) => void;
    options: FieldOption[];
    disabled?: boolean;
    className?: string;
}

export function DocumentTagToggle({
    value = [],
    onChange,
    options = [],
    disabled,
    className,
}: DocumentTagToggleProps) {
    return (
        <ToggleGroup
            type="multiple"
            value={value}
            onValueChange={onChange}
            disabled={disabled}
            className={cn('flex flex-wrap justify-start gap-2 h-auto', className)}
        >
            {options.map((option) => (
                <ToggleGroupItem
                    key={option.value}
                    value={option.value}
                    aria-label={option.label}
                    className="h-auto px-3 py-1.5 text-xs border border-input bg-transparent hover:bg-accent hover:text-accent-foreground data-[state=on]:bg-primary data-[state=on]:text-primary-foreground whitespace-normal text-left"
                >
                    {option.label}
                </ToggleGroupItem>
            ))}
        </ToggleGroup>
    );
}
